import { compose } from 'redux';
import actionTypes from './actionTypes';
import { serializeProductType } from '../serializers';

const initialState = {
    listing:{
        isLoading: false,
        areProductTypesLoaded: false,
        productTypesList: [],
        error: undefined,
    }
};

export default (state = initialState, action) => {
    switch(action.type){
    case actionTypes.LOAD_PRODUCT_TYPES_START:
        return {
            ...state,
            listing: {
                ...state.listing,
                isLoading: true
            },
        };
    case actionTypes.LOAD_PRODUCT_TYPES_SUCCESS:
        return {
            ...state,
            listing: {
                ...state.listing,
                isLoading: false, 
                areProductTypesLoaded: true,
                productTypesList: action.payload.data.map(serializeProductType),
            },
        };
    case actionTypes.LOAD_PRODUCT_TYPES_FAIL:
        return {
            ...state,
            listing: {
                ...state.listing,
                isLoading: false,
                error: action.payload.error
            },
        };
    default: 
        return state;
    }
};